export enum FileUploadChipStatus {
    NONE = 0,
    NEW,
    MODIFIED,
    PENDING,
    PENDING_DELETE,
    PENDING_UPLOAD,
    DELETED,
    IN_PROGRESS,
    UPLOADING,
    DOWNLOADING,
    SUCCESS,
    ERROR,
}
